// One date period for Product Activity, Batches and Reports (handoff §7l.3:
// "Reports uses the Product Activity calendar, the same component and the
// same range state (paFromD/paToD) already shared with Batches ... The period
// follows the user between Product Activity, Batches and Reports on purpose.")
//
// Kept for the rest of the browser tab, per sign-in, so a reload lands on it
// too (lib/keptDates.ts). A period left from an earlier day is forgotten, so
// nobody opens Product Activity tomorrow on a day they did not choose.

import { forgetKept, keepKept, readKept, useKeptDates } from '../../lib/keptDates'

export const SHARED_PERIOD_KEY = 'shared.period'

type Period = { from: string; to: string }
const DAY = /^\d{4}-\d{2}-\d{2}$/
const valid = (v: unknown): v is Period => {
  const p = v as Period | null
  return !!p && DAY.test(p.from) && DAY.test(p.to) && p.from <= p.to
}

export function sharedPeriod(today: string, uid?: string): Period {
  const p = readKept(SHARED_PERIOD_KEY, uid, today, valid)
  return p ? { from: p.from, to: p.to } : { from: today, to: today }
}

// Keeps the page's period as the shared one; `at` is when it was picked, for
// the "You're looking at…" prompt.
export function useSharedPeriod(uid: string | undefined, today: string, from: string, to: string) {
  return useKeptDates(SHARED_PERIOD_KEY, uid, today, { from, to })
}

export function setSharedPeriod(from: string, to: string, today: string, uid?: string) {
  keepKept(SHARED_PERIOD_KEY, uid, today, { from, to })
}

// Tests start each case on today.
export function resetSharedPeriod() {
  forgetKept(SHARED_PERIOD_KEY)
}
